import React, { useEffect, useRef } from 'react'
import MapView from "@arcgis/core/views/MapView";
import Map from "@arcgis/core/Map";

export default function EsriMap() {
    const mapDiv = useRef(null);
    useEffect(() => {
        if(mapDiv.current) {
            const webmap = new Map({
                basemap: "topo-vector"
            });

            const view = new MapView({
                container: mapDiv.current,
                map: webmap,
                center: [7.45, 53.25],
                scale: 200000
            });
            return () => view && view.destroy()
        }
    }, []);

  return (<div></div>
    //<div className='mapDiv' ref={mapDiv} style={{height: '500px'}}></div>
  )
}
